<div class="d-flex align-items-center">
  @if (showActiveInnovationSpaceImg) {
    <div
      class="d-flex align-items-center justify-content-between justify-content-sm-start"
    >
      @if (!standalone_widget_mode) {
        <div class="logo-fix-size">
          @if (selectedOrg?.imgUrl || (!selectedOrg?.imgUrl && !tenantLogo)) {
            <span class="organization__logo d-flex col-1 mx-3 pointer-cursor">
              <button
                class="btn-unstyled"
                (click)="navigateToActiveInnovationSpaceDetail(selectedOrg?.id)"
                appUnsavedFormCheck
              >
                <img
                  [src]="selectedOrg?.imgUrl"
                  appDefaultPlaceholder
                  [alt]="'tenant-logo'"
                />
              </button>
            </span>
          } @else {
            <div
              class="tenant-logo d-flex align-items-center logo-fix-size pointer-cursor"
            >
              <button
                class="btn-unstyled"
                (click)="navigateToActiveInnovationSpaceDetail()"
                appUnsavedFormCheck
              >
                <img
                  alt="tenant-logo"
                  [src]="tenantLogo"
                  appDefaultPlaceholder
                  appDynamicImgUrl
                />
              </button>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="align-items-center d-flex d-lg-none">
    <ng-container *ngTemplateOutlet="filterApplied"></ng-container>
  </div>
  <div
    class="global-filter flex-grow-1"
    [ngClass]="{ show: isMobileFilterMode }"
  >
    @if (sessionService?.isOnListPage) {
      <div class="global-filter__close">
        <button
          type="button"
          class="btn-close close"
          (click)="closeFilters()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    }

    <div class="d-flex flex-column w-auto">
      @if (
        (sessionService?.isOnListPage && showSearchBar) ||
        standalone_widget_mode
      ) {
        <div class="global-filter__search">
          <form
            (submit)="search()"
            action="#"
            class="global-filter__search-form"
          >
            <input
              type="text"
              name="query"
              class="form-control global-filter__search-input"
              placeholder="{{ 'Search' | translate }}"
              [(ngModel)]="searchKeyword"
            />
          </form>
          <div class="search-control">
            @if (this.searchKeyword) {
              <ng-icon
                name="matCloseOutline"
                class="reset-search me-3"
                appDebounceClick
                (debounceClick)="resetSearch()"
                focusable="false"
              ></ng-icon>
            }
            <ng-icon
              name="matSearchOutline"
              class="pointer-cursor"
              appDebounceClick
              (debounceClick)="search()"
            ></ng-icon>
          </div>
        </div>
      }

      @if (
        sessionService?.isOnDetailPage ||
        sessionService?.isOnListPage ||
        (!sessionService?.isOnListPage && !noFilterApplied)
      ) {
        <ng-container *ngTemplateOutlet="filterApplied"></ng-container>
      }
    </div>

    <ng-template #filterItems>
      <button
        class="btn-unstyled"
        (click)="onClickItem('box-all-innovation')"
        class="pointer-cursor d-flex"
        ngbDropdownItem
      >
        <input
          (change)="selectAll(organizationId, $event)"
          [(ngModel)]="allInnovation"
          id="box-all-innovation"
          type="checkbox"
        />

        <input
          [checked]="!organizationId"
          class="pointer-cursor"
          type="radio"
        />

        <label
          for="box-all-innovation"
          [class.selected-filter]="!organizationId"
          class="flex-grow-1 font-size-sm pointer-cursor"
          translate
          >All Innovation Spaces</label
        >
      </button>

      <div class="filter__orgs">
        @for (orgFilter of orgFilterList; track orgFilter.id) {
          @if (orgFilter | call: shouldShowFilterToken) {
            <button
              (click)="onClickItem('box-org-' + orgFilter.id)"
              class="d-flex pointer-cursor align-items-center btn-unstyled"
              ngbDropdownItem
              [ngbTooltip]="orgFilter.name"
            >
              <input
                [checked]="organizationId === orgFilter.id"
                class="pointer-cursor"
                type="radio"
              />
              <input
                (click)="
                  organizationId !== orgFilter.id &&
                    filterOrganizations(orgFilter.id)
                "
                (keydown.space)="
                  organizationId !== orgFilter.id &&
                    filterOrganizations(orgFilter.id)
                "
                [id]="'box-org-' + orgFilter.id"
                [ngModel]="organizationId === orgFilter.id"
                type="checkbox"
              />
              <app-organization-logo
                [className]="'filter__org-logo me-3'"
                [filterTokenUrl]="getFilterTokenUrl(orgFilter.id)"
                [organizationLogo]="orgFilter.imgUrl"
                showCopyText="true"
              ></app-organization-logo>
              <label
                [for]="'box-org-' + orgFilter.id"
                [class.selected-filter]="organizationId === orgFilter.id"
                class="flex-1 truncate-line-1 d-inline-block font-size-sm pointer-cursor"
                >{{ orgFilter.name }}
              </label>

              <button
                class="btn-unstyled ms-2"
                (click)="$event.stopPropagation(); removeItem(orgFilter)"
              >
                <ng-icon
                  name="matCloseOutline"
                  class="filter__orgs--gray pointer-cursor"
                ></ng-icon>
              </button>
            </button>
          }
        }
      </div>
    </ng-template>
    <ng-template #filterApplied>
      <div
        #dropdownRef
        (openChange)="positioningDropdown($event)"
        [autoClose]="'outside'"
        [placement]="dropDownPlacement"
        class="d-inline-block pointer-cursor"
        container="body"
        ngbDropdown
      >
        @if (!centralConfig.innovationSpaceId && !hide_innovation_space) {
          <div
            class="global-filter__applied py-2"
            [disableTooltip]="hasTouchInput || dropdown?.isOpen()"
            [ngbTooltip]="tooltip"
            [placement]="dropDownPlacement"
            container="body"
            ngbDropdownToggle
            id="filterCollapse"
          >
            <button
              class="btn-unstyled d-flex align-items-center"
              (click)="checkDropDown(dropdownRef)"
            >
              @if (
                sessionService?.isOnDetailPage ||
                (sessionService?.isOnListPage && !isMobileFilterMode)
              ) {
                <div class="filter m-0 me-2">
                  <!--          Dropdown block-->
                  @if (!isMobileFilterMode) {
                    <div class="d-inline-block">
                      <button
                        [class.filter__btn--active]="hasFilters"
                        class="filter__btn"
                      >
                        <app-internal-icon
                          [hasFilter]="hasFilters"
                          [height]="20"
                          [iconType]="IconType.PNG"
                          [name]="InternalIcon.InnovationSpace"
                        ></app-internal-icon>
                      </button>
                      <div
                        aria-labelledby="filterCollapse"
                        class="filter__dropdown-menu"
                        ngbDropdownMenu
                      >
                        @if (hasTouchInput) {
                          <div
                            class="mx-3 mt-3 mb-1 font-size-sm pointer-cursor"
                          >
                            <span translate>
                              UI.Common.Tooltip.FilterTokenListToggleButton
                            </span>
                            <div class="d-flex mt-3">
                              <ng-container
                                *ngTemplateOutlet="innovationLabel"
                              ></ng-container>
                            </div>
                          </div>
                        }
                        <div class="m-3">
                          <span class="filter__label-text">{{
                            'UI.GlobalFilter.InnovationSpaceList' | translate
                          }}</span>
                        </div>
                        <ng-container
                          *ngTemplateOutlet="filterItems"
                        ></ng-container>
                      </div>
                    </div>
                  }
                </div>
              }
              <ng-container
                *ngTemplateOutlet="
                  innovationLabel;
                  context: {
                    className: '',
                  }
                "
              ></ng-container>
            </button>
          </div>
        }
      </div>
    </ng-template>

    <ng-template #tooltip>
      <div
        class="filter__org-tooltip"
        translate
      >
        UI.Common.Tooltip.FilterTokenListToggleButton
      </div>
    </ng-template>

    <!--     innovation display lable block-->
    <ng-template
      #innovationLabel
      let-className="className"
    >
      <div
        [ngClass]="className"
        class="flex-shrink-0"
      >
        <span class="filter-applied-title">
          {{ 'UI.GlobalFilter.FilterApplied' | translate }}:</span
        >
      </div>

      <div
        [ngClass]="className"
        class="flex-1"
      >
        @if (!!organizationId && orgFilterList?.length > 0) {
          <span
            [ngbTooltip]="selectedOrg?.name"
            class="global-filter__org-name ms-1 fw-bold"
            >{{ selectedOrg?.name }}</span
          >
        }

        @if (noFilterApplied) {
          <span
            class="global-filter__org-name ms-1 fw-bold"
            translate
            >All Innovation Spaces</span
          >
        }
      </div>
    </ng-template>
  </div>
</div>

<ng-template #searchTemplate> </ng-template>
